import { render } from "./AppTag.vue?vue&type=template&id=04090ea0"
import script from "./AppTag.vue?vue&type=script&lang=ts"
export * from "./AppTag.vue?vue&type=script&lang=ts"
script.render = render

export default script